import { STORAGE } from 'application/constants'

export const wizardData = {
    store: (data) => {
        localStorage.removeItem(STORAGE.WIZARD_DATA)
        localStorage.setItem(STORAGE.WIZARD_DATA, JSON.stringify(data))
    },
    get: () => {
        const storageEntry = localStorage.getItem(STORAGE.WIZARD_DATA)
        return storageEntry === null ? [] : (JSON.parse(storageEntry))
    },
    delete: () => {
        localStorage.removeItem(STORAGE.WIZARD_DATA)
    }
}